import { StyledTBody, StyledTFoot, StyledTHead } from "./Table.styles";

/**
 * A styled `<thead>` element for rendering the table header section.
 *
 * Params
 * - children (ReactNode): The header content, typically table row(s) with header cells.
 * - ...props (any): Additional props passed to the StyledTHead component.
 *
 * Returns
 * - JSX.Element: A styled table head element.
 */
export const THead = ({ children, ...props }) => {
  return <StyledTHead {...props}>{children}</StyledTHead>;
};

/**
 * A styled `<tbody>` element for rendering the main body of the table.
 *
 * Params
 * - children (ReactNode): The body content, typically table row(s) with data cells.
 * - ...props (any): Additional props passed to the StyledTBody component.
 *
 * Returns
 * - JSX.Element: A styled table body element.
 */
export const TBody = ({ children, ...props }) => {
  return <StyledTBody {...props}>{children}</StyledTBody>;
};

/**
 * A styled `<tfoot>` element for rendering the footer section of the table.
 *
 * Params
 * - children (ReactNode): The footer content, typically table row(s) with summary cells.
 * - ...props (any): Additional props passed to the StyledTFoot component.
 *
 * Returns
 * - JSX.Element: A styled table footer element.
 */
export const TFoot = ({ children, ...props }) => {
  return <StyledTFoot {...props}>{children}</StyledTFoot>;
};
